import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { tplBusinessOpportunityActions } from './slice';
import capabilities from './capabilities';

export const ApiTplBusinessOpportunitiesGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplBusinessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/businessopportunities/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplBusinessOpportunityActions.setList(response?.data?.list));
                    dispatch(tplBusinessOpportunityActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplBusinessOpportunitiesCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('tplmgmt/businessopportunities/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiTplBusinessOpportunitiesPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplBusinessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/businessopportunities', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplBusinessOpportunityActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplBusinessOpportunitiesDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplBusinessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/businessopportunities/delete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplBusinessOpportunityActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplBusinessOpportunitiesExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(tplBusinessOpportunityActions.startExporting());
    }

    await gestopAPI
        .post(
            'tplmgmt/businessopportunities/export',
            { exportType, format, columns, filters, orderBy, groupBy },
            { ...config, responseType: 'blob' }
        )
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplBusinessOpportunityActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplBusinessOpportunityActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplBusinessOpportunitiesPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplBusinessOpportunityActions.startLoading());
    }

    await gestopAPI
        .put(`tplmgmt/businessopportunities/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplBusinessOpportunityActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplBusinessOpportunitiesPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplBusinessOpportunityActions.startLoading());
    }

    await gestopAPI
        .patch(`tplmgmt/businessopportunities/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplBusinessOpportunityActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplBusinessOpportunitiesDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplBusinessOpportunityActions.startLoading());
    }

    await gestopAPI
        .delete(`tplmgmt/businessopportunities/${id}`, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplBusinessOpportunityActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplBusinessOpportunitiesExportItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(tplBusinessOpportunityActions.startExporting());
    }

    await gestopAPI
        .get(`tplmgmt/businessopportunities/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplBusinessOpportunityActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplBusinessOpportunityActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplBusinessOpportunitiesGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplBusinessOpportunityActions.startLoading());
    }

    await gestopAPI
        .get(`tplmgmt/businessopportunities/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplBusinessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplBusinessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
